import ReviewSentiments from './review-sentiments.graphql';

const getReviewSentiments = () => {
  return ReviewSentiments;
};
export default getReviewSentiments;
